import React from "react";
import dental from "../assets/case-studies/dental-cs.png";

export default function DentalProtectionCaseStudy() {
  return (
    <div className="cs-pages">
      <img src={dental} alt="Dental Protection" width="80%" />
    </div>
  );
}
